import PartsType from '@/ts/if/CharaOptionPartsType'

class CharaOption {
  public type: PartsType = 'hair'
  public name = ''
  public dispName = ''
  public thumbPath = ''
  public imgPath: string[] = []
  public imgSvgPat: string[] = []

  constructor (initial?: Partial<CharaOption>) {
    Object.assign(this, initial)
  }
}

export default CharaOption
